{
  "name": "client-sds",
  "version": "1.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:hu": "ng serve --configuration hu",
    "start:sk": "ng serve --configuration sk",
    "start:hr": "ng serve --configuration hr",
    "build": "ng build",
    "prod-build": "ng build --configuration production",
    "test-build": "ng build --configuration test --source-map=true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:watch": "ng test --watch",
    "lint": "ng lint --fix",
    "postinstall": "husky",
    "i18n": "ng extract-i18n"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/cdk": "~20.2.14",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/material": "~20.2.14",
    "@angular/material-date-fns-adapter": "20.2.14",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@pozi/authmodule": "^0.0.19",
    "@stomp/rx-stomp": "^2.0.0",
    "@stomp/stompjs": "^7.0.0",
    "@typescript-eslint/types": "^8.26.0",
    "@typescript-eslint/utils": "^8.33.1",
    "angular-oauth2-oidc": "^17.0.1",
    "date-fns": "^3.3.1",
    "file-saver": "^2.0.5",
    "inter-ui": "^3.19.3",
    "material-symbols": "^0.24.0",
    "ngx-cookie-service": "20.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.23",
    "@angular-eslint/builder": "20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/schematics": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular/cli": "~20.3.23",
    "@angular/compiler-cli": "^20.3.18",
    "@angular/localize": "20.3.18",
    "@googlemaps/jest-mocks": "^2.21.4",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "^29.5.12",
    "@types/node": "^20.11.16",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "eslint": "^9.28.0",
    "husky": "^9.0.10",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "lint-staged": "^15.2.2",
    "ng-extract-i18n-merge": "latest",
    "prettier": "^3.5.3",
    "typescript": "5.8.3"
  }
}
